// extracted by mini-css-extract-plugin
export default {"titleContainer":"PostListView-styles__titleContainer__DjKMl","contentContainer":"PostListView-styles__contentContainer__W1ko0","sidenav":"PostListView-styles__sidenav__ToBsm"};